import React from 'react';
import { createPortal } from 'react-dom';
import { Trash2 } from 'lucide-react';

export default function DeleteConfirmModal({ onConfirm, onCancel, title, message }) {
  const modalContent = (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-5 sm:p-6 w-full max-w-sm animate-scale-in">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center shrink-0">
            <Trash2 className="w-5 h-5 text-red-600" />
          </div>
          <h3 className="text-lg font-bold text-gray-900">{title || 'Delete Prequalification'}</h3>
        </div>
        <p className="text-sm text-gray-600 mb-6">
          {message || 'Are you sure you want to delete this prequalification? This action cannot be undone and will remove all associated notes, payments, and data permanently.'}
        </p>
        <div className="flex gap-3 justify-end">
          <button 
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-xl transition-colors"
          >
            Cancel
          </button>
          <button 
            onClick={onConfirm}
            className="px-5 py-2 text-sm font-medium bg-red-600 hover:bg-red-700 text-white rounded-xl transition-colors"
          >
            Delete Permanently
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}
